import React, {Component, Fragment } from 'react';
import {observer} from "mobx-react";
import {reaction,toJS} from "mobx";
import qs from "qs";
import { DropTarget, DragDropContainer } from 'react-drag-drop-container';
import Dragger from "./Dragger";
import CheckMe from "./CheckMe";
import Buttons from "./Buttons";

import Str from "./Fields/Str";
import Int from "./Fields/Int";
import Decimal from "./Fields/Decimal";
import Bool from "./Fields/Bool";
import Image from "./Fields/Image";
import Color from "./Fields/Color";
import Datetime from "./Fields/Datetime";
import Button from "./Button";
import HTML from "../Helpers/HTML";
import File from "./Fields/File";

import objectPath from "object-path";

import setPlaceholders from "../../utils/setPlaceholders";
import Textarea from "./Fields/Textarea";
import {StoreContext} from "../../stores/contexts";
import MultiStr from "./Fields/MultiStr";
import MultiFile from "./Fields/MultiFile";

class Row extends Component {
  static contextType = StoreContext;

  constructor(props) {
    super(props);
    this.state={
      drag_enter_pos:''
    }
    reaction(
      ()=>{
        return this.context?this.context.dataStore.sort_mode:'';
      },
      (curSortMode)=>{
        if(!curSortMode && this.state.drag_enter_pos) {
          this.setState({ drag_enter_pos:'' });
        }
      }
    );
  }
  renderField(field,value,row) {
    let Comp;
    switch(field.view) {
      case "str":
        Comp=Str;
      break;
      case "textarea":
        Comp=Textarea;
      break;
      case "int":
        Comp=Int;
      break;
      case "decimal":
        Comp=Decimal;
      break;
      case "bool":
        Comp=Bool;
      break;
      case "image":
        Comp=Image;
      break;
      case "file":
        Comp=File;
      break;
      case "color":
        Comp=Color;
      break;
      case "datetime":
        Comp=Datetime;
      break;
      case "multi_str":
        Comp=MultiStr;
      break;
      case "multi_file":
        Comp=MultiFile;
      break;
    }
    if(Comp) {
      if(this.context.configStore.config.data.fields_urls[field.code]) {
        // console.log('field_urls', toJS(this.context.configStore.config.data.fields_urls[field.code]));
        return (
          <Button {...this.context.configStore.config.data.fields_urls[field.code]} row={row}>
            <Comp field={field} value={value} row={row}/>
          </Button>
        )
      } else {
        return <Comp field={field} value={value} row={row}/>;
      }
    }

    if(this.props.externalRenderer) {
      return this.props.externalRenderer(field.view, value, row, field);
    } else {
      if (typeof window.dynamicTableExternalRender !== 'undefined') {
        const ret = window.dynamicTableExternalRender(field.view, value, row, field);
        if (typeof ret !== 'undefined') {
          return <HTML>{ret}</HTML>;
        } else {
          return field.view + ':' + JSON.stringify(value);
        }
      }
    }
    return field.view+':'+JSON.stringify(value);
  }

  isElementDragging() {
    const idField=this.context.configStore.config.data.id_field;
    return this.context.dragStore.drag_source && this.context.dragStore.drag_source.map && this.context.dragStore.drag_source.map[this.props.item[idField]];
  }
  dropHit(pos, data) {
    const idField=this.context.configStore.config.data.id_field;
    this.context.dataStore.move(toJS(this.context.dragStore.drag_source.ids), pos, this.props.item[idField]);
    this.setState({ drag_enter_pos:'' });
  }

  renderDropContainers() {
    return this.context.dataStore.sort_mode && !this.isElementDragging()?(
        <>
          <DropTarget
            targetKey="section"
            onDragEnter={()=>{ this.setState({ drag_enter_pos:'top' }); console.log('top'); }}
            onDragLeave={()=>{ this.setState({ drag_enter_pos:'' }); }}
            onHit={(data)=>{ this.dropHit('before',data); }}
          >
            <div className="pa pa-tl w100 z3" style={{height:'50%'}}></div>
          </DropTarget>
          <DropTarget
            targetKey="section"
            onDragEnter={()=>{ this.setState({ drag_enter_pos:'bottom' }); console.log('bottom'); }}
            onDragLeave={()=>{ this.setState({ drag_enter_pos:'' }); }}
            onHit={(data)=>{ this.dropHit('after',data); }}
          >
            <div className="pa pa-bl w100 z3" style={{height:'50%'}}></div>
          </DropTarget>
        </>
      ):null;
  }

  onIframeAction(j) {
    if (j.answer.button == "apply") {
      return false;
    }
    if (j.answer.button == "cancel" || j.answer.button == "submit" || j.answer.button == "delete") {
      this.context.memoryStore.memory.iframe = null;
      this.context.memoryStore.buildMemory();
      return true;
    }
  }

  handleDoubleClick() {
    const hanlder=this.context.configStore.config.data.double_click;
    if(hanlder) {
      if(hanlder.set_url) {
        if(hanlder.open_in_iframe) {
          const ext = setPlaceholders(this.context.configStore.par, this.props.item, hanlder.set_url).split('?');
          const queryOb = qs.parse(ext[1])
          queryOb.mode = 'iframe';
          queryOb.sideblock = 'off';

          if(hanlder.iframe_action) {
            queryOb.onAction = 'onIframeAction';
            window.onIframeAction = (ob) => {
              return window[hanlder.iframe_action](ob, this.context.configStore.par);
            };
          } else {
            window.onIframeAction = (ob) => {
              return this.onIframeAction(ob);
            };
            queryOb.onAction = 'onIframeAction';
          }
          const query = qs.stringify(queryOb);
          this.context.memoryStore.memory.iframe = ext[0] + '?' + query;
          this.context.memoryStore.buildMemory();
        } else {
          window.location=setPlaceholders(this.context.configStore.par, this.props.item, hanlder.set_url);
        }
      }
      if(hanlder.on_click) {
        if(typeof window[hanlder.on_click] === "function") {
          window[hanlder.on_click](this.props.item, this.context.configStore.par);
        }
      }
    }
  }


  getAddColumns() {
    let cnt=1;
    if(this.context.configStore.config.data.enable_select || this.context.configStore.config.data.enable_drag) {
      cnt+=1;
    }
    return cnt;
  }
  getCellValue(item, code) {
    if(code.indexOf(".")>-1) {
      return objectPath.get(item, code);
    } else {
      return item[code];
    }
  }
  render() {
    const item=this.props.item;
    const idField=this.context.configStore.config.data.id_field;

    return (
      <>
        {this.state.drag_enter_pos === 'top'?(
          <tr style={{border:'none',fontSize:0, heigth:'0.01px', maxHeight:'0.01px'}}>
            <td style={{padding:0,border:'none', heigth:'0.01px', maxHeight:'0.01px'}} className="pr" colSpan={2+this.context.configStore.layout.length}>
              <div className="z3 pa w100 pbottom10 bg-b1-op50" style={{top:-5}}></div>
            </td>
          </tr>
        ):null}
        <tr onClick={()=>{ this.context.configStore.par.onRowClick(item); }} onDoubleClick={(e)=>{ e.preventDefault(); e.stopPropagation(); this.handleDoubleClick(); }} className={` ${this.context.configStore.par.getRowClassName(item)} hov pr itemRow ${this.isElementDragging()?"transp100":""} ${this.context.selectStore.selected[item[idField]]?'checked':''}`}>
          {this.context.configStore.config.data.enable_select || this.context.configStore.config.data.enable_drag?(
            <td className="wsnw pr">
              {this.context.configStore.config.data.enable_drag?(
                <Dragger row={item} />
              ):null}
              {this.context.configStore.config.data.enable_select?(
                <CheckMe row={item} />
              ):null}
            </td>
          ):null}
          {this.context.configStore.layout.map((field,index)=>{
            return (
              <td key={index} className="pr">
                {this.renderField(field,this.getCellValue(item, field.view_code || field.code),item)}
                {this.renderDropContainers()}
              </td>
            )
          })}
          <td className="wsnw pr">
            <Buttons row={item} buttons={this.context.configStore.config.data.action_buttons} />
            {this.renderDropContainers()}
          </td>
        </tr>
        {this.state.drag_enter_pos === 'bottom'?(
          <tr style={{border:'none',fontSize:0, heigth:'0.01px', maxHeight:'0.01px'}}>
            <td style={{padding:0,border:'none', heigth:'0.01px', maxHeight:'0.01px'}} className="pr" colSpan={this.getAddColumns()+this.context.configStore.layout.length}>
              <div className="z3 pa w100 pbottom10 bg-b1-op50" style={{top:-5}}></div>
            </td>
          </tr>
        ):null}
      </>
    )
  }
}

// export default inject("selectStore","selectStore","configStore","dragStore","dataStore","memoryStore")(observer(Row));
export default observer(Row);